const QUERIES = {
    GET_SESSION: 'get-session',
    GET_SCRIPT: 'get-script',
    GET_SCRIPTS: 'get-scripts',
}

export {QUERIES}